import type React from 'react';

import { Image, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { translationKey } from '@change-corgi/core/i18n';
import { Translate, TypedTranslate } from '@change-corgi/core/react/i18n';

import loadingImageUrl from 'src/assets/petition-loading-animation.gif';

const GENERATION_STATUS_KEYS = [
	translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.generation_in_progress.status_1'),
	translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.generation_in_progress.status_2'),
	translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.generation_in_progress.status_3'),
	translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.generation_in_progress.status_4'),
	translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.generation_in_progress.status_5'),
] as const;

export const DynamicTasksGenerationInProgress: React.FC<EmptyProps> = () => {
	return (
		<div className="flex w-full flex-col items-center gap-3 text-center" data-qa="dynamic-tasks-generation-in-progress">
			<div className="pointer-events-none flex h-auto w-full max-w-[165px] shrink-0 items-center justify-center">
				<Image
					src={loadingImageUrl}
					className="!aspect-auto h-auto max-h-[131px] w-auto max-w-full object-contain object-center"
					alt=""
					aria-hidden="true"
				/>
			</div>

			<div className="flex w-full max-w-md flex-col items-center gap-1 px-0">
				<div className="grid w-full grid-cols-1 grid-rows-1 place-items-center">
					{GENERATION_STATUS_KEYS.map((key, idx) => {
						const delay = idx * 2.5;

						return (
							<span
								key={key as unknown as string}
								className={cn(
									'col-start-1 row-start-1 flex w-full items-center justify-center',
									'animate-fade-in-out',
									'will-change-opacity will-change-transform',
									idx === 0 ? 'motion-reduce:animate-none motion-reduce:opacity-100' : 'motion-reduce:hidden',
								)}
								style={{ animationDelay: `${delay}s` }}
							>
								<Text
									as="p"
									variant="body"
									size="medium"
									fontWeight="normal"
									className="text-typography-strong m-0 text-center leading-6 font-normal tracking-normal"
								>
									<TypedTranslate value={key} />
								</Text>
							</span>
						);
					})}
				</div>

				<Text
					as="p"
					variant="body"
					size="small"
					fontWeight="normal"
					className="text-typography-weak m-0 w-full max-w-full text-center leading-5 font-normal tracking-normal"
				>
					<Translate value="corgi.petition.starter_dashboard_v2.dynamic_tasks.generation_in_progress.subtitle" />
				</Text>
			</div>
		</div>
	);
};
